import { render } from "./BovineByRegistrationChart.vue?vue&type=template&id=2a365354&scoped=true"
import script from "./BovineByRegistrationChart.vue?vue&type=script&lang=js"
export * from "./BovineByRegistrationChart.vue?vue&type=script&lang=js"

import "./BovineByRegistrationChart.vue?vue&type=style&index=0&id=2a365354&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a365354"]])

export default __exports__